export default __webpack_public_path__ + "static/media/n_liska_obecna-min.f565a688.jpg";